var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatformVkColorNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.828 1.828C0 3.655 0 6.597 0 12.48v1.04c0 5.883 0 8.825 1.828 10.652C3.655 26 6.597 26 12.48 26h1.04c5.883 0 8.825 0 10.652-1.828C26 22.345 26 19.403 26 13.52v-1.04c0-5.883 0-8.825-1.828-10.652C22.345 0 19.403 0 13.52 0h-1.04C6.597 0 3.655 0 1.828 1.828zm2.56 6.08c.14 6.76 3.52 10.823 9.446 10.823h.336v-3.868c2.178.217 3.824 1.81 4.485 3.868h3.077c-.845-3.077-3.066-4.778-4.453-5.428 1.387-.801 3.337-2.751 3.803-5.395h-2.795c-.607 2.145-2.405 4.095-4.117 4.28v-4.28h-2.795v7.497c-1.733-.433-3.922-2.535-4.02-7.497H4.389z",
    fill: "#ededf1",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformVkColorNegative);
export default __webpack_public_path__ + "static/media/platform-vk-color-negative.1ff115f7bcfb2bf8b8c2faaa86c0dc7d.svg";
export { ForwardRef as ReactComponent };